import React, { useEffect } from 'react';
import { Envelope, Envelopes } from '../../Capsules/Envelopes';
import { CheckoutWizardProps } from '../CheckoutWizardInterfaces';
import { usePushEvents } from '../../../../../hooks/PushEvents';
import {
    giftCauseScreen,
    selectOnGiftCause,
} from '../../../../../hooks/PushEvents/clevertapEvents';
import { FeatureFlag } from '../../../../../constants';
import { useFeatureFlag } from '../../../../../providers';
import { useDonorProfile } from '../../../../../api';

type EnvelopesWizardProps = CheckoutWizardProps;

const EnvelopesWizard: React.FC<EnvelopesWizardProps> = ({
    cart,
    donee,
    addToCart,
    setRoute,
}) => {
    const { donorProfile: donor } = useDonorProfile();
    const { pushEvent } = usePushEvents();
    const { isFeatureEnabled } = useFeatureFlag();
    useEffect(() => {
        pushEvent(giftCauseScreen, {
            loggedIn: Boolean(donor),
            doneeId: donee.idShort,
            currentSelectedAmount: cart.envelopes.new,
            'oga-appfooterdeeplinks': isFeatureEnabled(
                FeatureFlag.OGA_APPFOOTERDEEPLINKS,
            ),
        });
        //run only once when component is mounted
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (envelope: Envelope, amount: number) => {
        addToCart({ ...envelope, amount });
        setRoute('cart');
        pushEvent(selectOnGiftCause, {
            loggedIn: Boolean(donor),
            doneeId: donee.idShort,
            currentSelectedAmount: cart.envelopes.new,
            envelopeName: envelope.name,
            amount,
        });
    };
    return (
        <div>
            <Envelopes
                envelopes={donee.envelopes}
                cart={cart}
                currentAmount={cart.envelopes['new']!}
                onClick={handleClick}
            />
        </div>
    );
};

export default EnvelopesWizard;
